import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX, getColorForLabel } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const EChartsDoughnut = ({ data, titleText = "", colors }) => {
  const option = useMemo(() => {
    const labels = Object.keys(data || {});
    const values = Object.values(data || {});
    const total = values.reduce((a, b) => a + b, 0);
    const itemColors = labels.map((label, i) =>
      colors?.[i] || getColorForLabel(label, i)
    );

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        trigger: "item",
        formatter: (p) => {
          const pct = total ? ((p.value / total) * 100).toFixed(1) : 0;
          return `${p.name}: ${formatNumber(p.value)} (${pct}%)`;
        },
      },
      toolbox: ECHART_TOOLBOX,
      legend: {
        bottom: 0,
        type: "scroll",
        itemWidth: 10,
        itemHeight: 10,
        textStyle: { fontSize: 11 },
      },
      series: [
        {
          type: "pie",
          radius: ["42%", "68%"],
          center: ["50%", "45%"],
          avoidLabelOverlap: true,
          itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 2 },
          label: { show: false },
          emphasis: {
            label: { show: true, fontSize: 14, fontWeight: "bold" },
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.15)" },
          },
          data: labels.map((label, i) => ({
            name: label,
            value: values[i],
            itemStyle: { color: itemColors[i] },
          })),
          animationType: "scale",
          animationEasing: "elasticOut",
        },
      ],
    };
  }, [data, colors]);

  return <EChart option={option} />;
};

export default EChartsDoughnut;
